import { render } from "./FooterRight.vue?vue&type=template&id=edf7dc1c&scoped=true"
import script from "./FooterRight.vue?vue&type=script&lang=js"
export * from "./FooterRight.vue?vue&type=script&lang=js"

import "./FooterRight.vue?vue&type=style&index=0&id=edf7dc1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edf7dc1c"]])

export default __exports__